import React, {ReactNode} from 'react';
import {MODAL_COMPONENT_PROPS} from "@ui/modal/constants/modalProps";
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import {useThemeContext} from "@view/theme/context/hooks/useThemeContext";
import {SxProps} from '@mui/system'

interface IProps {
    open: boolean,
    onClose: () => void,
    children: ReactNode
    sx?:SxProps
}

const BaseModal = ({open, onClose, children, sx}: IProps) => {

    const {theme} = useThemeContext()

    return (
        <Modal
            keepMounted={false}
            open={open}
            onClose={onClose}
            componentsProps={MODAL_COMPONENT_PROPS}
        >
            <Box
                className={theme === 'dark' ? 'darkTheme' : 'lightTheme'}
                sx={sx}
            >
                {children}
            </Box>
        </Modal>
    );
};

export default BaseModal;